// extracted by mini-css-extract-plugin
module.exports = {"readOnline":"ReadDetail_readOnline__7lJZ0","subTitle":"ReadDetail_subTitle__pi3p6","readBtn":"ReadDetail_readBtn__X_S71"};